import React from "react";

export const AddProjectIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="none" viewBox="0 0 11 10">
      <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.2" d="M1.1 4.9h8.8M5.6.6v8.8"></path>
    </svg>
  );
};
